"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripNativePseudoFromSelector = exports.nativePseudoElementsSet = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@stylable/core");
exports.nativePseudoElementsSet = new Set(core_1.nativePseudoElements);
function stripNativePseudoFromSelector(str) {
    var e_1, _a;
    try {
        for (var nativePseudoElements_1 = tslib_1.__values(core_1.nativePseudoElements), nativePseudoElements_1_1 = nativePseudoElements_1.next(); !nativePseudoElements_1_1.done; nativePseudoElements_1_1 = nativePseudoElements_1.next()) {
            var name_1 = nativePseudoElements_1_1.value;
            var pseudo = '::' + name_1;
            if (str.endsWith(pseudo)) {
                return str.slice(0, 0 - pseudo.length);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nativePseudoElements_1_1 && !nativePseudoElements_1_1.done && (_a = nativePseudoElements_1.return)) _a.call(nativePseudoElements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return str;
}
exports.stripNativePseudoFromSelector = stripNativePseudoFromSelector;
//# sourceMappingURL=native-pseudo-elements-set.js.map